import { composeIO } from 'react-compose-io'
import { botaoIconeSvgIO } from './BotaoIconeSvg.IO'
import { BotaoIconeSvgView } from './BotaoIconeSvg.View'

export const BotaoIconeSvg = composeIO(BotaoIconeSvgView, botaoIconeSvgIO)
